module.exports = __webpack_public_path__ + "static/nextserver-demo-8019e05f65fb2857b4abbb8ea1afc3f7.gif";